<template>
    <v-card v-if="isUserCompany" flat color="transparent">
        <v-card-title class="px-0"> 링크 공유 </v-card-title>
        <v-card-subtitle class="px-0"> 링크를 참여자에게 공유하면 회의에 참석할 수 있습니다 </v-card-subtitle>
        <v-card flat color="grey lighten-5">
            <v-row class="ma-0" align="center">
                <v-col> {{ link }} </v-col>
                <v-col cols="auto">
                    <v-btn icon small @click="copy">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState({
            _user: (state) => state?.payload?._user,
        }),
        ...mapState("interview", {
            interview: "data",
        }),
        isUserCompany() {
            return this._user == this.interview?._company;
        },
        link() {
            return document.location;
        },
    },
    methods: {
        copy() {
            navigator.clipboard.writeText(this.link).then(() => alert("주소가 복사되었습니다"));
        },
    },
};
</script>

<style>
</style>